import { Guid, Nillable } from '@web/utils';
import { WarehouseProductType } from '../enums/warehouse-product-type';
import { QuantityUnit } from '@web/shared/module/measurement';

export class WarehouseProductDetails {
  public constructor(
    private readonly data: {
      id: Guid;
      type: WarehouseProductType;
      quantity: number;
      quantityUnit: QuantityUnit;
      sku: string;
      name: string;
      createdAt: Date;
      owner: string;
      ownerId: Guid;
      brand: string;
      brandId: Guid;
      localization?: Nillable<string>;
      localizationId?: Nillable<Guid>;
      promotion: boolean;
      durabilityInformation?: Nillable<string>;
      measure?: Nillable<string>;
      canBeViewed: boolean;
      canBeEdited: boolean;
      canBeLabelDownloaded: boolean;
      canBeQuantityEdited: boolean;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get type(): WarehouseProductType {
    return this.data.type;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get unit(): QuantityUnit {
    return this.data.quantityUnit;
  }

  public get sku(): string {
    return this.data.sku;
  }

  public get name(): string {
    return this.data.name;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get owner(): string {
    return this.data.owner;
  }

  public get ownerId(): Guid {
    return this.data.ownerId;
  }

  public get brand(): string {
    return this.data.brand;
  }

  public get brandId(): Guid {
    return this.data.brandId;
  }

  public get localization(): Nillable<string> {
    return this.data.localization;
  }

  public get localizationId(): Nillable<Guid> {
    return this.data.localizationId;
  }

  public get promotion(): boolean {
    return this.data.promotion;
  }

  public get durabilityInformation(): Nillable<string> {
    return this.data.durabilityInformation;
  }

  public get measure(): Nillable<string> {
    return this.data.measure;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeQuantityEdited(): boolean {
    return this.data.canBeQuantityEdited;
  }
}
